import React from 'react';
import contactPageData from '../../data/contact-page.json';

const hero = contactPageData.hero;

export default function ContactHero() {
    return (
        <section className="ch-hero">
            <style>{`
                .ch-hero {
                    position: relative;
                    padding: 160px 0 90px;
                    background: var(--eventflow-black);
                    overflow: hidden;
                    text-align: center;
                }
                .ch-hero::before {
                    content: '';
                    position: absolute; inset: 0;
                    background:
                        radial-gradient(ellipse at 50% 0%, rgba(var(--eventflow-primary-rgb),0.18) 0%, transparent 60%),
                        radial-gradient(ellipse at 80% 90%, rgba(var(--eventflow-base-rgb),0.1) 0%, transparent 50%);
                    pointer-events: none;
                }
                .ch-hero::after {
                    content: '';
                    position: absolute; inset: 0;
                    background-image:
                        linear-gradient(rgba(255,255,255,0.02) 1px, transparent 1px),
                        linear-gradient(90deg, rgba(255,255,255,0.02) 1px, transparent 1px);
                    background-size: 60px 60px;
                    pointer-events: none;
                }
                .ch-hero__inner { position: relative; z-index: 2; }
                .ch-hero__tag {
                    display: inline-flex; align-items: center; gap: 8px;
                    font-family: var(--eventflow-font);
                    font-size: 12px; font-weight: 700;
                    letter-spacing: 3px; text-transform: uppercase;
                    color: var(--eventflow-base); margin-bottom: 20px;
                }
                .ch-hero__tag::before, .ch-hero__tag::after {
                    content: ''; display: inline-block;
                    width: 28px; height: 1px;
                    background: var(--eventflow-base); opacity: 0.5;
                }
                .ch-hero__title {
                    font-family: var(--eventflow-font);
                    font-size: 64px; font-weight: 900;
                    color: #fff; line-height: 1.05;
                    letter-spacing: -2px; margin-bottom: 18px;
                }
                .ch-hero__title span {
                    background: linear-gradient(135deg, var(--eventflow-base) 0%, #ff4d9e 100%);
                    -webkit-background-clip: text;
                    -webkit-text-fill-color: transparent;
                    background-clip: text;
                }
                .ch-hero__sub {
                    font-family: var(--eventflow-font);
                    font-size: 17px; color: rgba(255,255,255,0.5);
                    max-width: 520px; margin: 0 auto;
                    line-height: 1.75;
                }
                @media (max-width: 768px) {
                    .ch-hero { padding: 130px 0 60px; }
                    .ch-hero__title { font-size: 40px; letter-spacing: -1px; }
                }
            `}</style>

            <div className="container">
                <div className="ch-hero__inner wow fadeInUp" data-wow-delay="100ms">
                    <div className="ch-hero__tag">{hero.tag}</div>
                    <h1 className="ch-hero__title">
                        {hero.title}<span>{hero.titleAccent}</span>
                    </h1>
                    <p className="ch-hero__sub">
                        {hero.subtitle}
                    </p>
                </div>
            </div>
        </section>
    );
}
